import React from "react";
import {BaseThatsMeIconProps} from "../../../interfaces/baseThatsMeIconProps.interface";

export default (props: BaseThatsMeIconProps) => {
    const {size = 24} = props;
    return <svg width={size} height={size} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_1836_8565" maskUnits="userSpaceOnUse" x="0" y="0" width="72"
              height="72">
            <circle cx="36" cy="36" r="36" fill="#83FFAD"/>
        </mask>
        <g mask="url(#mask0_1836_8565)">
            <rect x="-28.2856" y="-12" width="128.571" height="95.1429" fill="#C0EC78"/>
        </g>
        <path
            d="M22.0524 23L24.8858 28.7857H30.5524L27.7191 23H31.4969L34.3302 28.7857H39.9969L37.1636 23H40.9413L43.7747 28.7857H49.4413L46.608 23H49.9494C50.8183 23 51.5443 23.2976 52.1273 23.8929C52.7104 24.4882 53.0013 25.2294 53 26.1166V46.8854C53 47.7725 52.7091 48.5137 52.1273 49.109C51.5456 49.7043 50.8196 50.0013 49.9494 50H22.0506C21.1817 50 20.4563 49.703 19.8746 49.109C19.2928 48.515 19.0013 47.7731 19 46.8834V26.1166C19 25.2281 19.2915 24.4869 19.8746 23.8929C20.4576 23.2989 21.1829 23.0013 22.0506 23"
            fill="#160267"/>
    </svg>
}
